// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperAbstract-cls1__d86d29881271517b884e{/*!*/}.PaperAbstract-cls2___77d4229041fe6a78079{display:flex;flex-direction:column;align-items:flex-start;flex:1 0;grid-gap:8px;gap:8px;grid-gap:var(--spacing-xs-8, 8px);gap:var(--spacing-xs-8, 8px);overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperAbstract-cls1__d86d29881271517b884e",
	"cls2": "PaperAbstract-cls2___77d4229041fe6a78079 PaperAbstract-cls1__d86d29881271517b884e"
};
export default ___CSS_LOADER_EXPORT___;
